import moment from "moment";

import AsyncCallHandler from "../common/AsyncCallHandler";
import NEXUS_CONST from "../common/constants";
import ACTION_TYPES from "./actionTypes";

export const exportScheduleAttainmentData = (payload = null) => {
  const name = payload.isAll
    ? `scheduleAttainment-all`
    : `scheduleAttainment_${moment(payload.startDate).format(
        "YYYY-MM-DD"
      )}_to_${moment(payload.endDate).format("YYYY-MM-DD")}`;

  AsyncCallHandler(
    "SchAttainment/exportSchAttainmentData",
    NEXUS_CONST.POST,
    payload,
    NEXUS_CONST.BLOB
  ).then((res) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name + ".xlsx");
    document.body.appendChild(link);
    link.click();
  });
};

export const fetchDailyInputTarget = (dispatch, query) => {
  AsyncCallHandler(
    "SchAttainment/GetDailyInputTarget?tierId=" + query,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_SA_TARGET, payload: res.data });
  });
};

export const fetchReasonCodes = (dispatch, tier) => {
  AsyncCallHandler(
    `DigitalTier/GetOPHReasoncodeListData?level=1&TierID=${tier}`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_SA_REASON_CODES, payload: res.data });
  });
};

export const fetchDailyInputDetails = (dispatch, tierId, shift, date) => {
  AsyncCallHandler(
    `SchAttainment/GetDailyInputDetails?tierId=${tierId}&shift=${shift}&date=${date}`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_SA_DAILY_INPUT_DETAILS,
      payload: res.data,
    });
  });
};

export const addDailyInput = (dispatch, data) => {
  AsyncCallHandler(
    "SchAttainment/ManageDailyInputDataforSchAttainment",
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.REFRESH_SCH_ATTAINMENT_WIDGET,
      payload: res.data,
    });
  });
};

export const fetchSchAttainmentRunChart = (dispatch, payload) => {
  AsyncCallHandler(
    `SchAttainment/SchAttainmentRunChart?TierId=${payload.tierId}&Date=${payload.date}`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_SCH_ATTAINMENT_RUN_CHART,
      payload: res.data,
    });
  });
};

export const fetchSchAttainmentMissReasonCodeFrequency = (
  dispatch,
  payload
) => {
  AsyncCallHandler(
    `SchAttainment/GetSchAttainmentMissReasonCodeFrequencyById`,
    NEXUS_CONST.POST,
    payload
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_SCH_ATTAINMENT_MISS_REASON_CODE_FREQ,
      payload: res.data,
    });
  });
};

export const fetchReasonCodeLevel0 = (dispatch, tierId) => {
  AsyncCallHandler(
    `FPY/GetDailyInputReasonCodebyType?TierID=${tierId}&level=0&isRejected=false`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_REASON_CODE_LEVEL_O", payload: res.data });
  });
};

export const fetchReasonCodeLevel1 = (dispatch, tierId) => {
  AsyncCallHandler(
    `FPY/GetDailyInputReasonCodebyType?TierID=${tierId}&level=1&isRejected=false`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_REASON_CODE_LEVEL_1", payload: res.data });
  });
};

export const fetchReasonCodeLevel2 = (dispatch, tierId) => {
  AsyncCallHandler(
    `FPY/GetDailyInputReasonCodebyType?TierID=${tierId}&level=2&isRejected=false`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_REASON_CODE_LEVEL_2", payload: res.data });
  });
};



